import React from 'react'
import { normalizeParentGuardianData } from '../../utilities'
import { ReviewParentGuardian } from './ReviewParentGuardian'

export const ReviewParentGuardians = ({ values, ...props }) => {
  const parentGuardians = normalizeParentGuardianData(values, 9, 0, true)
  const singleParentGuardian = parentGuardians.length == 1

  return parentGuardians.map((parentGuardian, index) => {
    const editFieldName = `parentguardian_first_name_${index}`
    const parentGuardianProps = {
      ...parentGuardian,
      ...props,
      editFieldName
    }
    return (
      <section key={editFieldName}>
        {singleParentGuardian ? (
          <h2>Parent/Guardian</h2>
        ) : (
          <h2>Parent/Guardian {index + 1}</h2>
        )}
        <ReviewParentGuardian {...parentGuardianProps} />
      </section>
    )
  })
}
